<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

    <ng-container *ngIf="consulta">
        <div class="body">
            <div class="card-msg d-flex flex-column flex-md-row px-1">
                <div class="w-100 d-flex justify-content-between py-1 px-2">
                    <span class="text-secondary">LIMITE SUGERIDO:</span>
                    <span>R$: {{ consulta?.valorTotal || msgNull }} (TOTAL)</span>
                </div>
            </div>
            <div class="row p-2 py-2">
                <span class="px-1 font-weight-normal text-justify f-14 format-compacta">
                    O limite de crédito PJ foi calculado com base em referênciais de negócios * ponderado pela classificação de risco de
                    crédito da empresa medida pelas tecnologias de ratings e scorings (*) referênciais de negócios = faturamento real,
                    faturamento presumido, média e valores da última compra, maior fatura ou maior acúmulo.
                </span>
            </div>
        </div>
    </ng-container>
    
</app-card-consulta>